const binding = { modules: {}, dataActions: {} };

    (binding.modules['image-grid'] = {
        c: () => require('partner/modules/image-grid/image-grid.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'image-grid',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/image-grid'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|image-grid|image-grid'] = {
                c: () => require('partner/modules/image-grid/image-grid.view.tsx'),
                cn: '__local__-__local__-image-grid'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };